export default new class Faq {
  constructor () {
    this.init()
  }

  init () {
    window.addEventListener('load', () => {
      this.setActive()
    })
  }

  setActive () {
    const pillsButton = document.querySelectorAll('.js-faq-button')
    pillsButton.forEach(button => {
      button.addEventListener('click', () => {
        button.classList.contains('active') ?  button.classList.remove("active") : button.classList.add("active")
        const content = button.closest('.js-faq-item').querySelector('.js-faq-content')
        if(content) {
          content.classList.contains('hidden') ? content.classList.remove("hidden") : content.classList.add("hidden")
        }
      })
    })
  }
}()
